import {defineMessages} from 'react-intl'

import {iconsList} from '@vio/atlas/Icon'
import {RoomsFilterKey} from '@vio/core/src/room/business/utils/filters'

type FilterConfigItem = {
  id: RoomsFilterKey
  icon: keyof typeof iconsList
}

// TODO [typesscript>=4.9]: This should use the `satisfies` operator
export const filtersConfig: FilterConfigItem[] = [
  {
    id: RoomsFilterKey.DealFreeze,
    icon: 'Ice'
  },
  {
    id: RoomsFilterKey.FreeCancellation,
    icon: 'CalendarCheck4'
  },
  {
    id: RoomsFilterKey.BreakfastIncluded,
    icon: 'Restaurant'
  },
  {
    id: RoomsFilterKey.PayLater,
    icon: 'CreditCard'
  }
]

export const messages = defineMessages<RoomsFilterKey>({
  freeCancellation: {
    id: 'cancellationPenalties.freeCancellation',
    defaultMessage: 'Free cancellation'
  },
  breakfastIncluded: {
    id: 'mealType.breakfastIncluded',
    defaultMessage: 'Breakfast Included'
  },
  payLater: {id: 'paymentSchedule.payLater', defaultMessage: 'Pay later'},
  dealFreeze: {id: 'dealFreeze.freezable', defaultMessage: 'Freezable'}
})
